import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';
import { Select, Store } from '@ngxs/store';
import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import { noop, Observable } from 'rxjs';
import { filter, tap } from 'rxjs/operators';
import { ReportLayout, ReportTypeQueryParamValues } from '../reports/reports.types';
import { ReportingCreateModalComponent } from './@components/modals/create/create.component';
import { CreateReportModel } from './reporting.types';
import { Report } from './state/actions';
import { ReportingState } from './state/state';

@Component({
  selector: 'app-reporting',
  templateUrl: './reporting.component.html',
  styleUrls: ['./reporting.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportingComponent extends OnDestroyMixin implements OnInit {
  @Select(ReportingState.getLayouts) stateLayouts$: Observable<ReportLayout<any>[]>;
  @Select(ReportingState.getSelectedLayout) selectedLayout$: Observable<ReportLayout<any>>;

  layouts$: Observable<ReportLayout<any>[]>;

  constructor(private readonly store: Store, private readonly matDialog: MatDialog, private readonly router: Router) {
    super();
  }

  ngOnInit(): void {
    this.store.dispatch(new Report.Get({ report_types: [ReportTypeQueryParamValues.SingleObject] }));

    this.layouts$ = this.stateLayouts$.pipe(
      untilComponentDestroyed(this),
      tap((layouts) => {
        if (layouts?.length) {
          this.router.navigate(['reporting', 'list']);
        }
      }),
    );

    this.selectedLayout$
      .pipe(
        untilComponentDestroyed(this),
        filter((layout) => !!layout),
        tap((layout) => this.router.navigate(['reporting', 'builder', layout.id])),
      )
      .subscribe(noop);
  }

  create(): void {
    this.matDialog
      .open(ReportingCreateModalComponent, {
        autoFocus: false,
      })
      .afterClosed()
      .pipe(
        untilComponentDestroyed(this),
        filter((report) => !!report),
        tap((report: CreateReportModel) => this.store.dispatch(new Report.Create(report))),
      )
      .subscribe(noop);
  }
}
